import { MessageCircle, Sparkles } from "lucide-react";

const SessionsEmptyState = ({
  title = "No conversations yet",
  subtitle = "Ask Anything to begin",
}: SessionsEmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      {/* Icon with subtle animation */}
      <div className="mb-4 p-3 rounded-full relative bg-gradient-to-br from-gray-100/80 to-gray-50/80 text-gray-400 dark:from-neutral-800/50 dark:to-neutral-800/30 dark:text-neutral-400">
        <MessageCircle size={24} className="relative z-10" />

        {/* Subtle sparkle effect */}
        <Sparkles
          size={12}
          className="absolute -top-1 -right-1 animate-pulse text-gray-300 dark:text-neutral-500"
        />
      </div>

      {/* Main message */}
      <h3 className="text-sm font-medium mb-2 text-gray-700 dark:text-neutral-300">
        {title}
      </h3>

      {/* Subtitle */}
      <p className="text-xs mb-4 max-w-[180px] leading-relaxed text-gray-500 dark:text-neutral-500">
        {subtitle}
      </p>
    </div>
  );
};

type SessionsEmptyStateProps = {
  title?: string;
  subtitle?: string;
};

export default SessionsEmptyState;
